const cx = (...classNames) => classNames.filter(Boolean).join(" ");

export { cx };
